import { render, staticRenderFns } from "./ProductTeaserWrapper.vue?vue&type=template&id=61754edd"
import script from "./ProductTeaserWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTeaserWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports